import { useQuery } from '@tanstack/react-query';
import { getFolderContents } from '../../api/edms/folders';

function getContentsList(response) {
  if (!response) return { folder: null, folders: [], items: [], pagination: null };
  const d = response.data ?? response;
  const folder = d?.folder ?? null;
  const folders =
    Array.isArray(d?.childrenFolders) ? d.childrenFolders
    : Array.isArray(d?.folders) ? d.folders
    : Array.isArray(d?.children) ? d.children
    : [];
  const items =
    Array.isArray(d?.documents) ? d.documents
    : Array.isArray(d?.items) ? d.items
    : [];
  const pagination = d?.pagination ?? response?.pagination ?? null;
  return { folder, folders, items, pagination };
}

/**
 * @param {string} folderId - Folder ID
 * @param {Object} [options] - { enabled, page, limit } for documents pagination
 */
export const useFolderContents = (folderId, options = {}) => {
  const { page = 1, limit = 10 } = options;
  const query = useQuery({
    queryKey: ['folderContents', folderId, page, limit],
    queryFn: () => getFolderContents({ folderId, page, limit }),
    enabled: options.enabled !== false && !!folderId,
  });

  const { folder, folders, items, pagination } = getContentsList(query.data);

  const normalizedPagination = pagination
    ? {
        currentPage: pagination.page ?? pagination.currentPage ?? 1,
        totalPages: (pagination.pages ?? pagination.totalPages ?? Math.ceil((pagination.total ?? 0) / (pagination.limit ?? limit))) || 1,
        hasPrevPage: (pagination.page ?? 1) > 1,
        hasNextPage: (pagination.page ?? 1) < (pagination.pages ?? pagination.totalPages ?? 1),
      }
    : null;

  return {
    ...query,
    folder,
    folders,
    items,
    pagination: normalizedPagination,
  };
};

export default useFolderContents;
